import React, { useState, useEffect, useLayoutEffect } from "react";
import Modal from "components/UI/Modal/Modal";
import { InsertModal, UpdateModal, DeleteModal } from "./Actions";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { routeInfo, userCredentials } from "recoilState/GlobalState";
import { HeaderButton } from "components";
import Add from "@mui/icons-material/Add";
import Cached from "@mui/icons-material/Cached";
import EditOutlined from "@mui/icons-material/EditOutlined";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import { Buttons } from "components";
import { ACTIONS } from "consts/Actions";
import { titulosTitles as titles } from "consts/titulos-de-tablas";
import styles from "styles/pages/Pages.module.scss";
import { useService, puedeEditarServicio } from "components/route/ServiceRoute";
import XGrid from "components/UI/Grid/XGrid";
import { RNHTituloGet } from "services/services-mia/programa-salud/personal/RNHTituloGet";

export default function Titulos() {
  const credentials = useRecoilValue(userCredentials);
  const setRoute = useSetRecoilState(routeInfo);
  const [modalDetails, setModalDetails] = useState({ isOpen: false });
  const [loading, setLoading] = useState(false);
  const [titulos, setTitulos] = useState([]);
  const [rowSelected, setRowSelected] = useState({ status: false, row: {} });
  const { service } = useService();

  const getTitulos = async () => {
    setTitulos([]);
    setRowSelected({ status: false, row: {} });
    setLoading(true);
    const { data: result } = await RNHTituloGet(credentials);
    const newRows = result[0]?.rnhTituloId ? result?.map((data) => {
      return {
        id: data.rnhTituloId,
        cod: data.rnhTituloCod,
        name: data.rnhTituloNombre,
        matricula: data?.rnhTituloRequiereMatricula === "Y" ? 'Si' : 'No',
        wkt: data.rnhTituloWKT,
        // No son columnas: viajan en la fila para que Modificar y Eliminar no
        // tengan que volver a pedir el registro.
        version: data.rnhTituloVersion,
        // El valor crudo para el select; `matricula` es el Si/No de la grilla.
        matriculaCod: data?.rnhTituloRequiereMatricula ?? "",
      };
    }) : []
    setTitulos(newRows);
    setLoading(false);
  }
  const closeModal = () => {
    setModalDetails({ isOpen: false });
  };
  const handleClick = ({ procede, title }) => {
    setModalDetails({ procede, title, isOpen: true });
  };

  useEffect(() => {
    getTitulos()
  }, [])
  useLayoutEffect(() => {
    setRoute({
      wordKey: `Títulos - Programa Salud RN`
    })
  }, [service.servicioNombre, setRoute])

  return (
    <main className={styles.main}>
      <Modal
        size={modalDetails.procede === ACTIONS.DELETE ? 'sm' : 'md'}
        open={modalDetails.isOpen}
        title={modalDetails.title}
        onClose={closeModal}
      >
        {modalDetails.procede === ACTIONS.UPDATE && (
          <UpdateModal
            row={rowSelected.row}
            updateList={getTitulos}
            closeModal={closeModal}
          />
        )}
        {modalDetails.procede === ACTIONS.DELETE && (
          <DeleteModal
            row={rowSelected.row}
            servicio={service}
            updateList={getTitulos}
            closeModal={closeModal}
            setterRowSelected={setRowSelected}
          />
        )}
        {modalDetails.procede === ACTIONS.INSERT && (
          <InsertModal
            servicio={service}
            updateList={getTitulos}
            closeModal={closeModal}
          />
        )}
      </Modal>
      <div className={styles["filters-actions-right"]}>
        <Buttons>
          <HeaderButton
            text={"Actualizar"}
            onClick={() => { getTitulos() }}
            disabled={rowSelected.row.id || false}
          >
            <Cached />
          </HeaderButton>
          <HeaderButton
            text={"Nuevo Título"}
            handleClick={handleClick}
            data={{
              title: "Nuevo Título",
              procede: ACTIONS.INSERT
            }}
            disabled={rowSelected.row.id || service.servicioPermiso !== 'E'}
          >
            <Add />
          </HeaderButton>
          <HeaderButton
            text={"Modificar Título"}
            handleClick={handleClick}
            data={{
              title: "Modificar Título",
              procede: ACTIONS.UPDATE
            }}
            disabled={!puedeEditarServicio(service) || (!rowSelected.row.id)}
          >
            <EditOutlined />
          </HeaderButton>
          <HeaderButton
            text={"Eliminar Título"}
            handleClick={handleClick}
            data={{
              title: "Eliminar Título",
              procede: ACTIONS.DELETE
            }}
            disabled={!puedeEditarServicio(service) || (!rowSelected.row.id)}
          >
            <DeleteOutlineRoundedIcon />
          </HeaderButton>
        </Buttons>
      </div>
      <div className={styles.container}>
        <XGrid
          rows={titulos}
          titles={titles}
          loading={loading}
          secondarySelected={rowSelected}
          setSecondarySelected={setRowSelected}
        />
      </div>
    </main>
  );
}